import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../../services/api";

export default ({ user, setUser }) => {
  const [resume, setResume] = useState(user.resume || "");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await api.put(`/user/${user._id}`, { resume });
      setUser({ ...user, resume });
      toast.success("Resume saved!");
    } catch (e) {
      console.error(e);
      toast.error("Error saving resume");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-medium">Resume</h3>
        <button
          onClick={handleSave}
          disabled={saving}
          className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
      <textarea
        className="w-full h-[60vh] p-4 border border-gray-200 rounded-md focus:ring-1 focus:ring-blue-500 focus:border-blue-500 outline-none resize-none text-sm leading-relaxed"
        value={resume}
        onChange={(e) => setResume(e.target.value)}
        placeholder="Write resume notes about this person..."
      />
    </div>
  );
};
